import { Theme, css } from '@emotion/react';

export const defalutInformation = (theme: Theme) => css`
  a:hover {
    background-color: ${theme.palette.grayscale[3]};
    transition: background 0.35s;
  }
`;
